import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card-analysis" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "code" }
const _hoisted_4 = { class: "status" }
const _hoisted_5 = { class: "label" }
const _hoisted_6 = { class: "value uppercase" }
const _hoisted_7 = {
  key: 0,
  class: "status"
}
const _hoisted_8 = { class: "label" }
const _hoisted_9 = { class: "value" }
const _hoisted_10 = {
  key: 1,
  class: "status"
}
const _hoisted_11 = { class: "label" }
const _hoisted_12 = { class: "value" }
const _hoisted_13 = {
  key: 2,
  class: "time"
}
const _hoisted_14 = { class: "label" }
const _hoisted_15 = { class: "value" }
const _hoisted_16 = {
  key: 3,
  class: "employee"
}
const _hoisted_17 = { class: "label" }
const _hoisted_18 = { class: "value" }
const _hoisted_19 = {
  key: 4,
  class: "employee"
}
const _hoisted_20 = { class: "label" }
const _hoisted_21 = { class: "value" }
const _hoisted_22 = {
  key: 5,
  class: "employee"
}
const _hoisted_23 = { class: "label" }
const _hoisted_24 = { class: "value" }
const _hoisted_25 = {
  key: 6,
  class: "employee"
}
const _hoisted_26 = { class: "label" }
const _hoisted_27 = { class: "value" }
const _hoisted_28 = {
  key: 7,
  class: "technical"
}
const _hoisted_29 = { class: "label" }
const _hoisted_30 = { class: "value" }
const _hoisted_31 = {
  key: 8,
  class: "employee"
}
const _hoisted_32 = { class: "label" }
const _hoisted_33 = { class: "value" }
const _hoisted_34 = {
  key: 9,
  class: "employee"
}
const _hoisted_35 = { class: "label" }
const _hoisted_36 = { class: "value" }
const _hoisted_37 = { class: "actions" }
const _hoisted_38 = { class: "text-3" }
const _hoisted_39 = { class: "text-3" }

import { computed } from "vue";
import { useI18n } from "vue-i18n";

import { getDateAndHour, getDifference } from "@/common/utils/dates";

import { AnalysisListType } from "@/common/types/analysis";
import { svgIcon } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'card-analysis',
  props: {
    data: {},
    editable: { type: Boolean, default: true }
  },
  emits: ["edit", "copy", "delete"],
  setup(__props: any, { emit: __emit }) {

const { t, tm } = useI18n();

const emit = __emit;

const props = __props;

const statusList: { [key: string]: string } = {
  PENDING: "time",
  STARTED: "time-b",
  WARNING: "info",
  CANCELED: "close",
  CONCLUDED: "confirmed",
  FINISHED: "confirmed",
};

const statusColor: { [key: string]: string } = {
  PENDING: "#666",
  STARTED: "#666",
  WARNING: "orange",
  CANCELED: "red",
  CONCLUDED: "green",
  FINISHED: "green",
};

const enumAnalysisStatus = computed(
  () => tm("enums.analysis_status") as Record<string, string>
);

const methods = computed(
  () => props.data?.methods?.map((item) => item.code) ?? []
);

const samples = computed(
  () => props.data?.samples?.map((item) => item.code) ?? []
);

const equipments = computed(
  () => props.data?.equipments?.map((item) => item.code) ?? []
);

const results = computed(
  () => props.data?.results?.map((item) => item.name) ?? []
);

const forms = computed(() => props.data?.forms?.map((item) => item.code) ?? []);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(__props.data.code), 1),
        _createElementVNode("span", {
          style: _normalizeStyle({ color: statusColor[__props.data.status] })
        }, [
          _createVNode(_unref(svgIcon), {
            size: "1.5rem",
            icon: statusList[__props.data.status]
          }, null, 8, ["icon"])
        ], 4)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)("common.labels.status")) + ": ", 1),
        _createElementVNode("span", _hoisted_6, _toDisplayString(enumAnalysisStatus.value[__props.data?.status]), 1)
      ]),
      (__props.data.start_date)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)("common.labels.start")) + ": ", 1),
            _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(getDateAndHour)(__props.data.start_date)), 1)
          ]))
        : _createCommentVNode("", true),
      (__props.data.end_date)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)("common.labels.termination")) + ": ", 1),
            _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(getDateAndHour)(__props.data.end_date)), 1)
          ]))
        : _createCommentVNode("", true),
      (__props.data.start_date)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(t)("common.labels.time")) + ": ", 1),
            _createElementVNode("span", _hoisted_15, [
              (__props.data.start_date && !__props.data.end_date)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_unref(getDifference)(__props.data.start_date, new Date().toISOString(), false)
                  .text), 1)
                  ], 64))
                : (__props.data.start_date && __props.data.end_date)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_unref(getDifference)(__props.data.start_date, __props.data.end_date, false).text), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createTextVNode(" 0h 0m ")
                    ], 64))
            ])
          ]))
        : _createCommentVNode("", true),
      (samples.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("span", _hoisted_17, [
              (samples.value.length === 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_unref(t)("common.labels.sample")) + ": ", 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_unref(t)("common.labels.samples")) + ": ", 1)
                  ], 64))
            ]),
            _createElementVNode("span", _hoisted_18, _toDisplayString(samples.value.join(", ")), 1)
          ]))
        : _createCommentVNode("", true),
      (forms.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("span", _hoisted_20, [
              (forms.value.length === 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_unref(t)("common.labels.form")) + ": ", 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_unref(t)("common.labels.forms")) + ": ", 1)
                  ], 64))
            ]),
            _createElementVNode("span", _hoisted_21, _toDisplayString(forms.value.join(", ")), 1)
          ]))
        : _createCommentVNode("", true),
      (methods.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createElementVNode("span", _hoisted_23, [
              (methods.value.length === 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_unref(t)("common.labels.method")) + ": ", 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_unref(t)("common.labels.methods")) + ": ", 1)
                  ], 64))
            ]),
            _createElementVNode("span", _hoisted_24, _toDisplayString(methods.value.join(", ")), 1)
          ]))
        : _createCommentVNode("", true),
      (equipments.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _createElementVNode("span", _hoisted_26, [
              (equipments.value.length === 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_unref(t)("common.labels.equipment")) + ": ", 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_unref(t)("common.labels.equipments")) + ": ", 1)
                  ], 64))
            ]),
            _createElementVNode("span", _hoisted_27, _toDisplayString(equipments.value.join(", ")), 1)
          ]))
        : _createCommentVNode("", true),
      (__props.data.member_id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(t)("common.labels.technical")) + ": ", 1),
            _createElementVNode("span", _hoisted_30, _toDisplayString(__props.data.technical?.first_name) + " " + _toDisplayString(__props.data.technical?.last_name), 1)
          ]))
        : _createCommentVNode("", true),
      (__props.data.employee_id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
            _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(t)("common.labels.employee")) + ": ", 1),
            _createElementVNode("span", _hoisted_33, _toDisplayString(__props.data.employee?.first_name) + " " + _toDisplayString(__props.data.employee?.last_name), 1)
          ]))
        : _createCommentVNode("", true),
      (results.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
            _createElementVNode("span", _hoisted_35, [
              (results.value.length === 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_unref(t)("common.labels.result")) + ": ", 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_unref(t)("common.labels.results")) + ": ", 1)
                  ], 64))
            ]),
            _createElementVNode("span", _hoisted_36, _toDisplayString(results.value.join(", ")), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("button", {
        class: "btn btn-sm btn-white",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('edit')))
      }, [
        _createVNode(_unref(svgIcon), {
          icon: "edit",
          size: "1.25rem"
        }),
        _createElementVNode("span", _hoisted_38, _toDisplayString(_unref(t)("common.labels.edit")), 1)
      ]),
      _createElementVNode("button", {
        class: "btn btn-sm btn-delete",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('delete')))
      }, [
        _createVNode(_unref(svgIcon), {
          icon: "trash",
          size: "1.25rem"
        }),
        _createElementVNode("span", _hoisted_39, _toDisplayString(_unref(t)("common.labels.delete")), 1)
      ])
    ])
  ]))
}
}

})